export default "__VITE_ASSET__By70x5DA__"